import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import { Modal, Button, Row, Col, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { handleError } from '../../shared/ErrorCatching';
import DateTime from 'react-datetime';
import notify from '../../shared/feedback/notifications';
import * as InvoiceActions from './InvoiceActions';
import FormSelect from '../../components/common/FormSelect';
import ValidatableFormGroup from '../../components/common/ValidatableFormGroup';
import moment from 'moment';

interface ICreatePaymentModalProps {
    invoiceId: number;

    paymentAmount: number;
    paymentDate: Date;
    selectDate(date: Date): void;
    modalAmountValueChange(): void;

    closeModal(reloadList?: boolean): void;
    newPayment: {
        invoiceNumber: string;
        invoiceCurrency: { value: number; displayName: string };
        currency: { value: number; displayName: string };
        availablePaymentTypes: { id: string; name: string }[];
    };
    actions: {
        createPayment(
            invoiceId: number,
            date: Date,
            comment: string,
            amount: number,
            originalAmount: number,
            paymentType: number
        ): Promise<void>;
        newPayment(invoiceId: number);
    };
}

class CreatePaymentModal extends React.Component<ICreatePaymentModalProps, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            amountIncludingVATInInvoiceCurrency: 0,
            comment: '',
            paymentType: '1',
            invoiceNumber: null,
            errors: {}
        };

        this.onChange = this.onChange.bind(this);
        this.savePayment = this.savePayment.bind(this);
    }

    componentDidMount() {
        this.props.actions.newPayment(this.props.invoiceId);
    }

    onChange(e: any) {
        this.setState({ [e.target.name]: e.target.value });
    }

    savePayment() {
        this.props.actions
            .createPayment(
                this.props.invoiceId,
                this.props.paymentDate,
                this.state.comment,
                this.props.paymentAmount,
                this.state.amountIncludingVATInInvoiceCurrency,
                this.state.paymentType
            )
            .then(() => {
                notify.success(
                    Translate('invoice-history/create-payment-modal/notification/payment-saved')
                );
                this.props.closeModal(true);
            })
            .catch((error: any) =>
                handleError(error, (errors: any) => {
                    this.setState({ errors });
                })
            );
    }

    render() {
        return (
            <Modal show={true} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Translate('invoice-history/create-payment-modal/title')}{' '}
                        {this.props.newPayment.invoiceNumber}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6}>
                            <ValidatableFormGroup
                                required={true}
                                validationKey="paymentType"
                                errors={this.state.errors}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'invoice-history/create-payment-modal/payment-type/label'
                                    )}
                                </ControlLabel>
                                <FormSelect
                                    name="paymentType"
                                    value={this.state.paymentType}
                                    onChange={this.onChange}
                                >
                                    <option value=""></option>
                                    {this.props.newPayment.availablePaymentTypes &&
                                        this.props.newPayment.availablePaymentTypes.map(
                                            (p: any) => {
                                                return (
                                                    <option key={p.id} value={p.id}>
                                                        {Translate(p.name)}
                                                    </option>
                                                );
                                            }
                                        )}
                                </FormSelect>
                            </ValidatableFormGroup>
                        </Col>
                        {this.props.newPayment.invoiceCurrency &&
                            this.props.newPayment.currency.value !==
                                this.props.newPayment.invoiceCurrency.value && (
                                <Col md={3}>
                                    <ValidatableFormGroup
                                        required={true}
                                        validationKey="amountIncludingVATInInvoiceCurrency"
                                        errors={this.state.errors}
                                    >
                                        <ControlLabel>
                                            {Translate(
                                                'invoice-history/create-payment-modal/amount/label'
                                            )}{' '}
                                            {this.props.newPayment.invoiceCurrency
                                                ? this.props.newPayment.invoiceCurrency.displayName
                                                : ''}
                                        </ControlLabel>
                                        <FormControl
                                            type="number"
                                            name="amountIncludingVATInInvoiceCurrency"
                                            value={this.state.amountIncludingVATInInvoiceCurrency}
                                            onChange={this.onChange}
                                        />
                                    </ValidatableFormGroup>
                                </Col>
                            )}
                        <Col
                            md={
                                this.props.newPayment.invoiceCurrency &&
                                this.props.newPayment.currency.value !==
                                    this.props.newPayment.invoiceCurrency.value
                                    ? 3
                                    : 6
                            }
                        >
                            <ValidatableFormGroup
                                required={true}
                                validationKey="amountInclVAT"
                                errors={this.state.errors}
                            >
                                <ControlLabel>
                                    {Translate('invoice-history/create-payment-modal/amount/label')}{' '}
                                    {this.props.newPayment.currency
                                        ? this.props.newPayment.currency.displayName
                                        : ''}
                                </ControlLabel>
                                <FormControl
                                    type="number"
                                    name="amountInclVAT"
                                    value={this.props.paymentAmount}
                                    onChange={this.props.modalAmountValueChange}
                                />
                            </ValidatableFormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup className="required">
                                <ControlLabel>
                                    {Translate('invoice-history/create-payment-modal/date/label')}
                                </ControlLabel>
                                <DateTime
                                    locale={moment.locale()}
                                    value={this.props.paymentDate}
                                    timeFormat={false}
                                    onChange={(newValue) => {
                                        const value = newValue ? newValue.toDate() : null;
                                        this.props.selectDate(value);
                                    }}
                                    closeOnSelect={true}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate(
                                        'invoice-history/create-payment-modal/comment/label'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    componentClass="textarea"
                                    name="comment"
                                    value={this.state.comment}
                                    onChange={this.onChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.savePayment} bsStyle="default">
                        {Translate('invoice-history/create-payment-modal/footer/save')}
                    </Button>
                    <Button onClick={() => this.props.closeModal()} bsStyle="default">
                        {Translate('invoice-history/create-payment-modal/footer/close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        newPayment: state.invoices.newPayment
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            newPayment: (invoiceId: number) => dispatch(InvoiceActions.getNewPayment(invoiceId)),
            createPayment: (
                invoiceId: number,
                date,
                comment,
                amountInclVAT,
                amountIncludingVATInInvoiceCurrency,
                paymentType
            ) =>
                dispatch(
                    InvoiceActions.createPayment(
                        invoiceId,
                        date,
                        comment,
                        amountInclVAT,
                        amountIncludingVATInInvoiceCurrency,
                        paymentType
                    )
                )
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePaymentModal);
